<!-- search bar -->
<div class="content-wrap">
    <div class="container">
        <div class="breadcrumb">
            <app-bread-crumb [data]="breadCrumb"></app-bread-crumb>
        </div>
        <div class="title-catalogue d-flex justify-content-between align-items-center">
            <h2>{{ 'IRONSIDE.product-catalog.PRODUCT_CATALOG' | translate }}</h2>
            <span (click)="showDialog()" class="btn-common btn-modal" href="">
                {{ 'IRONSIDE.product-catalog.EDIT_CATALOG' | translate }}
            </span>
        </div>
        <div class="content-catalogue d-flex justify-content-between flex-wrap">
            <ng-container *ngFor="let category of catalogs">
                <div class="catalogue-item">
                    <h3>
                        <a class="categoryLv1" (click)="goToSearchPage(category)">{{ category?.nameCategory | translateDynamicLanguage }}</a>
                    </h3>
                    <div class="catalogue-body">
                        <ul>
                            <ng-container *ngFor="let category2 of category.subcategoryList">
                                <li>
                                    <a (click)="goToSearchPage(category2)">> {{ category2.nameCategory | translateDynamicLanguage }}</a>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
